import { Directive, InjectionToken } from '@angular/core';

export const KT_PORTLET_STICKY = new InjectionToken<KtPortletSticky>('KtPortletSticky');

@Directive({
	selector: 'ktPortletSticky,[ktPortletSticky]',
	providers: [{ provide: KT_PORTLET_STICKY, useExisting: KtPortletSticky }],
})
export class KtPortletSticky {}
